import styled from 'styled-components';
import { ReactComponent as SangixLogo } from 'images/Logo/sangix-logo.svg';
import { toRem } from 'utils/helpers';

export const AppointmentsPrintHeaderWrapper = styled.div`
  display: none;

  @media print {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--s3);
  }
`;

export const AppointmentsPrintHeaderLogo = styled(SangixLogo)`
  height: ${toRem(32)}rem;
  width: auto;
`;

export const AppointmentsPrintHeaderSiteInfo = styled.div`
  text-align: right;
  font-weight: 500;
`;
